import React from 'react';
import { animated } from 'react-spring';
import { useReveal } from '../../hooks/useReveal';

export function Reveal({
  children,
  style = {},
  config,
  ...rest
}: {
  children?: React.ReactNode;
  style?: any;
  className?: string;
  config?: any;
}) {
  const reveal = useReveal(config);
  return (
    <animated.div
      ref={reveal.ref}
      style={{
        ...style,
        ...reveal.style,
      }}
      {...rest}
    >
      {children}
    </animated.div>
  );
}
